<script>
import BookingSectionRadio from './BookingSectionRadio';
import BookingSectionCheckbox from './BookingSectionCheckbox';
import BookingSectionInputName from './BookingSectionInputName';
import BookingSectionInputBirth from './BookingSectionInputBirth';
import BookingSectionInputAddress from './BookingSectionInputAddress';
import BookingSectionInputDinco from './BookingSectionInputDinco';

import _find from 'lodash/find'

export default {
  components: {
    BookingSectionCheckbox,
    BookingSectionRadio,
    BookingSectionInputName,
    BookingSectionInputBirth,
    BookingSectionInputAddress,
    BookingSectionInputDinco
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    formField: {
      type: Array,
      required: true,
    },
    alias: {
      type: [String, Number],
      required: true,
    },
    inputData: {
      type: Object,
      default: () => {}
    },
    formValid: {
      type: [Boolean, String],
      default: false
    }
  },
  data() {
    return {
      isOpen: true,
      formData: {},
      complate: false,
    }
  },
  computed: {
    hasRequired() {
      return this.formField.some(item => {
        return item.required
      })
    },
    fieldName() {
      const field = _find(this.formField, ({ type }) => type === 'name');

      const data = field
        ? this.formData[field.id] || ''
        : '';

      return !field ? '' : data.replace(` ${this.$t('global.MALE' /* 先生 */)}`, '').replace(` ${this.$t('global.FEMALE' /* 小姐 */)}`, '');
    },
    fieldCompany() {
      const field = _find(this.formField, ({ type }) => type === 'company');

      const data = field
        ? this.formData[field.id] || ''
        : '';

      return !field ? '' : data;
    },
    validBirth() {
      const field = _find(this.formField, ({ type }) => type === 'birth');
      const isRequired = field ? field.required : false;

      return !field || !isRequired
        ? false
        : (this.formData[field.id] || '').length === 0;
    },
    validAddress() {
      const field = _find(this.formField, ({ type }) => type === 'address');
      const isRequired = field ? field.required : false;

      return !field || !isRequired
        ? false
        : (this.formData[field.id] || '').length <= 6;
    },
    validNameAndComputeOnlyOne() {
      const hasFieldName = !!_find(this.formField, ({ type }) => type === 'name');
      const hasFieldCompany = !!_find(this.formField, ({ type }) => type === 'company');

      return hasFieldName && hasFieldCompany
        ? (this.fieldName || !this.fieldCompany) && (!this.fieldName || this.fieldCompany)
        : false;
    },
    isFormValid() {
      const requiredExtrafield = this.formField.filter(item => {
        return item.required && !item.adminEdit
      });

      const compute = requiredExtrafield.every(item => {
        return this.formData[item.id]
          && (
            typeof this.formData[item.id] === 'object'
            && this.formData[item.id].length > 0
            || typeof this.formData[item.id] !== 'object'
          )
      });

      const hasNameOrCompute = !this.fieldName && !this.fieldCompany;

      return !compute || hasNameOrCompute || this.validNameAndComputeOnlyOne || this.validBirth || this.validAddress;
    },
  },
  watch: {
    inputData: {
      handler(v, ov) {
        this.formData = v
      },
      deep: true
    },
    formData: {
      handler(v, ov) {
        this.$emit('update:inputData', v)
      },
      deep: true
    },
    isFormValid: {
      handler(v, ov) {
        this.$emit('update:formValid', v)
      },
      deep: true
    }
  },
  mounted() {
    /* this.formField.forEach(item => {
      this.$set(this.formData, item.id, '')
    }) */
    this.$emit('update:formValid', this.isFormValid);

    this.setFromData();
    this.setAdminEditData();
  },
  methods: {
    setFromData() {
      /* this.$nextTick(() => {
        Object.keys(this.inputData).forEach(key => {
          this.$set(this.formData, key, this.inputData[key])
        })
      }) */
      this.$nextTick(() => {
        this.formField.forEach(item => {
          if(this.formData[item.id]) {
            this.formData[item.id] = this.inputData ? this.inputData[item.id] : ''
          }
        })
      })
    },
    setAdminEditData() {
      this.$nextTick(() => {
        this.formField.forEach(item => {
          if(item.default) {
            this.$set(this.formData, item.id, this.inputData ? this.inputData[item.id] : '')
          }
        })
      })
    }
  },
  // inject: ['$validator'],
}

</script>
<template>
  <div class="booking-section" style="margin-top: 0;margin-bottom: 1rem;box-shadow: 0 0 5px 0 rgba(178, 180, 181,0.35);">

    <div class="level subsection is-small is-mobile" :style="!isOpen ? 'border-bottom: 0' : ''" @click="isOpen = !isOpen">
      <div class="level-left" :class="$style.toggleLeft"> 
        <h4 class="booking-section__title booking-section__title-individual">
          <div :class="$style.bookingToggle">
            <div>
              <BaseIcon v-if="isOpen" name="angle-down" class-name="fa-fw"/>
              <BaseIcon v-else name="angle-right" class-name="fa-fw"/>              
            </div>
            <div :class="$style['bookingToggle_title']">
              {{title}}
            </div>
          </div>
        </h4>
      </div>
      <div class="level-right">
        <span v-if="!isFormValid" style="color: rgb(191, 126, 69);">
          <BaseIcon name="check" class-name="fa-fw"/>
          {{$t('global.SIZE_EXTRAFIELD_GROUP_COMPLATE' /*填寫完成*/)}}
        </span>
        <span v-else>
          <BaseIcon name="check" class-name="fa-fw has-text-grey-light"/>
          {{$t('global.SIZE_EXTRAFIELD_GROUP_UNCOMPLATE' /*尚未完成*/)}}
        </span>
      </div>
    </div>
    <div v-show="isOpen" class="subsection">
      <template v-for="(sizeExtrafield, index2) in formField">
        <template v-if="!sizeExtrafield.adminEdit">
          <template v-if="sizeExtrafield.value">
            <b-field
              :key="index2"
              class="is-style-extrafield-text"
              :label="sizeExtrafield.title"
              :class="{ [$style['isRequired']]: sizeExtrafield.required }"
            >
              <b-input
                v-model.trim="formData[sizeExtrafield.id]"
                :name="`${sizeExtrafield.id}_${alias}`"
                expanded
              ></b-input>
            </b-field>
          </template>
          <template v-else>
            <BookingSectionInputName
              v-if="sizeExtrafield.type === 'name'"
              :key="index2"
              :input-data.sync="formData[sizeExtrafield.id]"
              :field="sizeExtrafield"
              :name="`${sizeExtrafield.id}_${alias}`"
            />
            <BookingSectionInputBirth
              v-if="sizeExtrafield.type === 'birth'"
              :key="index2"
              :input-data.sync="formData[sizeExtrafield.id]"
              :field="sizeExtrafield"
              :name="`${sizeExtrafield.id}_${alias}`"
            />
            <BookingSectionInputAddress
              v-if="sizeExtrafield.type === 'address'"
              :key="index2"
              :input-data.sync="formData[sizeExtrafield.id]"
              :field="sizeExtrafield"
              :name="`${sizeExtrafield.id}_${alias}`"
            />
            <BookingSectionInputDinco
              v-if="sizeExtrafield.type === 'dinco'"
              :key="index2"
              :input-data.sync="formData[sizeExtrafield.id]"
              :field="sizeExtrafield"
              :name="`${sizeExtrafield.id}_${alias}`"
            />
            <BookingSectionCheckbox
              v-if="sizeExtrafield.type === 'checkbox'"
              :key="index2"
              :input-data.sync="formData[sizeExtrafield.id]"
              :field="sizeExtrafield"
              :name="`${sizeExtrafield.id}_${alias}`"
            />
            <BookingSectionRadio
              v-if="sizeExtrafield.type === 'radio'"
              :key="index2"
              :input-data.sync="formData[sizeExtrafield.id]"
              :field="sizeExtrafield"
              :name="`${sizeExtrafield.id}_${alias}`"
            />
            <b-field
              v-if="sizeExtrafield.type === 'text' || sizeExtrafield.type === 'company' || sizeExtrafield.type === 'phone'"
              :key="index2"
              :message="errors.first(`${sizeExtrafield.id}_${alias}`)"
              :type="{ 'is-danger': errors.has(`${sizeExtrafield.id}_${alias}`) }"
              class="is-style-extrafield-text"
              :label="sizeExtrafield.title"
              :class="{ [$style['isRequired']]: sizeExtrafield.required }"
            >
              <b-input
                v-model.trim="formData[sizeExtrafield.id]"
                v-validate="{ required: Boolean(sizeExtrafield.required) }"
                :data-vv-as="sizeExtrafield.title"
                :name="`${sizeExtrafield.id}_${alias}`"
                expanded
              ></b-input>
            </b-field>
            <div
              v-if="sizeExtrafield.type === 'name' && validNameAndComputeOnlyOne && fieldName"
              style="margin-top: -8px;margin-bottom: 20px;font-size: 15px;color: rgb(133, 36, 38);">
              姓名與公司行號請擇一填寫
            </div>
            <div
              v-if="sizeExtrafield.type === 'company' && validNameAndComputeOnlyOne && fieldCompany"
              style="margin-top: -15px;margin-bottom: 20px;font-size: 15px;color: rgb(133, 36, 38);">
              姓名與公司行號請擇一填寫
            </div>
          </template>
        </template>
      </template>
    </div>

    <!--
      <pre>formData: {{formData}}</pre>
    <pre>isFormValid: {{isFormValid}}</pre>
    <pre>formField: {{formField}}</pre>-->
  </div>
</template>
<style lang="scss" module>
  .isRequired {
    :global(.label::after) {
      margin-left: 4px;
      color: $color-danger;
      content: '*';
    }
  }
  .toggleLeft{
    width: 60%;
    .bookingToggle{
      display: flex;
      align-items: center;
      &_title{
        padding-left: 0.5rem;
      }
    }
   }
   
</style>
